import { render, staticRenderFns } from "./pre_test_questions.vue?vue&type=template&id=a0628e5e"
import script from "./pre_test_questions.vue?vue&type=script&lang=js"
export * from "./pre_test_questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports